export const translations = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About',
      features: 'Features',
      contact: 'Contact'
    },
    hero: {
      slides: [
        {
          title: 'Handcrafted Pareo',
          titleGradient: 'Excellence',
          description: 'Premium hand-painted pareos crafted by skilled artisans using traditional Indonesian techniques',
          cta1: 'View Collection',
          cta2: 'Contact Us',
          badge: 'Premium Quality'
        },
        {
          title: 'Custom Design',
          titleGradient: 'Solutions',
          description: 'Tailored designs to match your brand vision with flexible MOQ and export-ready production',
          cta1: 'Start Custom Order',
          cta2: 'Learn More',
          badge: 'B2B Specialist'
        },
        {
          title: 'Sustainable',
          titleGradient: 'Manufacturing',
          description: 'Eco-friendly production processes with ISO certified quality standards for global markets',
          cta1: 'Our Process',
          cta2: 'Get Quote',
          badge: 'ISO Certified'
        }
      ]
    },
    products: {
      title: 'Handcrafted',
      titleGradient: 'Excellence',
      subtitle: 'Premium pareo collection with modern contemporary designs',
      cta: 'View Complete Collection',
      card: {
        type: 'Product Type',
        material: 'Material Options',
        production: 'Production Method',
        moq: 'MOQ',
        custom: 'Custom Design',
        export: 'Export Ready',
        available: 'Available',
        yes: 'Yes'
      }
    },
    about: {
      title: 'Crafting Quality',
      titleGradient: 'Since 1999',
      description: 'Bahtera Lima Utama is a leading manufacturer of hand-painted pareos, combining traditional Indonesian artistry with modern production capabilities. Our factory in Banyuwangi serves global B2B clients with custom design solutions and consistent quality.',
      mission: 'Our mission is to preserve traditional textile arts while delivering world-class manufacturing services to international brands and distributors.',
      badge1: '25+ Years',
      badge2: 'ISO Certified',
      values: [
        {
          title: 'Artisan Expertise',
          description: 'Skilled craftspeople with decades of experience in traditional textile arts'
        },
        {
          title: 'Quality Control',
          description: 'Rigorous inspection processes ensuring consistent premium quality'
        },
        {
          title: 'Global Standards',
          description: 'ISO certified production meeting international export requirements'
        },
        {
          title: 'Sustainable Practices',
          description: 'Eco-friendly materials and processes for responsible manufacturing'
        }
      ],
      stats: {
        established: '1999',
        staff: '60 Employees',
        production: '10,000+ Monthly'
      }
    },
    features: {
      title: 'Artisan',
      titleGradient: 'Excellence',
      subtitle: 'Why leading brands choose Azure Textile',
      items: [
        {
          title: 'Handcrafted Excellence',
          description: 'Each piece is carefully hand-painted by skilled artisans using traditional techniques passed down through generations'
        },
        {
          title: 'Premium Materials',
          description: 'Only the finest fabrics sourced from certified suppliers, ensuring durability and luxurious feel'
        },
        {
          title: 'Custom Designs',
          description: 'Full design customization service to match your brand identity with unlimited color and pattern options'
        },
        {
          title: 'Fast Delivery',
          description: 'Efficient production workflow with 2-4 week turnaround for standard orders and reliable export logistics'
        },
        {
          title: 'Quality Guarantee',
          description: 'ISO certified quality management system with comprehensive inspection and defect-free guarantee'
        },
        {
          title: 'Eco-Friendly Process',
          description: 'Sustainable production using water-based dyes and environmentally responsible manufacturing practices'
        }
      ]
    },
    contact: {
      title: "Let's Create",
      titleGradient: 'Together',
      subtitle: 'Start your custom pareo project with Bahtera Lima Utama',
      form: {
        services: 'Select Service',
        serviceOptions: [
          'Custom Design',
          'Bulk Order',
          'Sample Request',
          'Partnership Inquiry'
        ],
        name: 'Full Name',
        phone: 'Phone Number',
        email: 'Email Address',
        message: 'Your Message',
        messagePlaceholder: 'Tell us about your project requirements, desired quantity, timeline, and any specific design preferences...',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully! We\'ll respond within 24 hours.',
        error: 'Failed to send message. Please try again.'
      },
      info: {
        title: 'Contact Information',
        address: 'Factory Address',
        addressDetail: 'Gepuro, Watukebo, Kec. Rogojampi, Kabupaten Banyuwangi, Jawa Timur 68462',
        phone: 'Phone Number',
        email: 'Email Address',
        hours: 'Business Hours',
        hoursDetail: 'Monday - Saturday: 8:00 AM - 5:00 PM',
        whatsapp: 'Chat on WhatsApp'
      }
    },
    whatsapp: {
      message: 'Hello Bahtera Lima Utama! I\'m interested in learning more about your pareo products.'
    }
  },
  id: {
    nav: {
      home: 'Beranda',
      products: 'Produk',
      about: 'Tentang',
      features: 'Keunggulan',
      contact: 'Kontak'
    },
    hero: {
      slides: [
        {
          title: 'Pareo Buatan',
          titleGradient: 'Tangan',
          description: 'Pareo premium yang dilukis tangan oleh pengrajin terampil menggunakan teknik tradisional Indonesia',
          cta1: 'Lihat Koleksi',
          cta2: 'Hubungi Kami',
          badge: 'Kualitas Premium'
        },
        {
          title: 'Solusi Desain',
          titleGradient: 'Kustom',
          description: 'Desain yang disesuaikan dengan visi merek Anda dengan MOQ fleksibel dan produksi siap ekspor',
          cta1: 'Mulai Pesanan Kustom',
          cta2: 'Pelajari Lebih Lanjut',
          badge: 'Spesialis B2B'
        },
        {
          title: 'Manufaktur',
          titleGradient: 'Berkelanjutan',
          description: 'Proses produksi ramah lingkungan dengan standar kualitas bersertifikat ISO untuk pasar global',
          cta1: 'Proses Kami',
          cta2: 'Dapatkan Penawaran',
          badge: 'Bersertifikat ISO'
        }
      ]
    },
    products: {
      title: 'Keunggulan',
      titleGradient: 'Kerajinan',
      subtitle: 'Koleksi pareo premium dengan desain kontemporer modern',
      cta: 'Lihat Koleksi Lengkap',
      card: {
        type: 'Jenis Produk',
        material: 'Pilihan Material',
        production: 'Metode Produksi',
        moq: 'MOQ',
        custom: 'Desain Kustom',
        export: 'Siap Ekspor',
        available: 'Tersedia',
        yes: 'Ya'
      }
    },
    about: {
      title: 'Menghasilkan Kualitas',
      titleGradient: 'Sejak 1999',
      description: 'Bahtera Lima Utama adalah produsen terkemuka pareo yang dilukis tangan, menggabungkan seni tekstil tradisional Indonesia dengan kapabilitas produksi modern. Pabrik kami di Banyuwangi melayani klien B2B global dengan solusi desain kustom dan kualitas konsisten.',
      mission: 'Misi kami adalah melestarikan seni tekstil tradisional sambil memberikan layanan manufaktur kelas dunia kepada merek dan distributor internasional.',
      badge1: '25+ Tahun',
      badge2: 'Bersertifikat ISO',
      values: [
        {
          title: 'Keahlian Pengrajin',
          description: 'Pengrajin terampil dengan puluhan tahun pengalaman dalam seni tekstil tradisional'
        },
        {
          title: 'Kontrol Kualitas',
          description: 'Proses inspeksi ketat memastikan kualitas premium yang konsisten'
        },
        {
          title: 'Standar Global',
          description: 'Produksi bersertifikat ISO memenuhi persyaratan ekspor internasional'
        },
        {
          title: 'Praktik Berkelanjutan',
          description: 'Material dan proses ramah lingkungan untuk manufaktur yang bertanggung jawab'
        }
      ],
      stats: {
        established: '1999',
        staff: '60 Karyawan',
        production: '10.000+ Per Bulan'
      }
    },
    features: {
      title: 'Keunggulan',
      titleGradient: 'Pengrajin',
      subtitle: 'Mengapa merek terkemuka memilih Azure Textile',
      items: [
        {
          title: 'Keunggulan Buatan Tangan',
          description: 'Setiap potong dilukis dengan hati-hati oleh pengrajin terampil menggunakan teknik tradisional yang diwariskan turun-temurun'
        },
        {
          title: 'Material Premium',
          description: 'Hanya kain terbaik yang bersumber dari pemasok bersertifikat, memastikan daya tahan dan nuansa mewah'
        },
        {
          title: 'Desain Kustom',
          description: 'Layanan kustomisasi desain penuh untuk mencocokkan identitas merek Anda dengan opsi warna dan pola tak terbatas'
        },
        {
          title: 'Pengiriman Cepat',
          description: 'Alur kerja produksi efisien dengan waktu penyelesaian 2-4 minggu untuk pesanan standar dan logistik ekspor yang andal'
        },
        {
          title: 'Jaminan Kualitas',
          description: 'Sistem manajemen kualitas bersertifikat ISO dengan inspeksi komprehensif dan jaminan bebas cacat'
        },
        {
          title: 'Proses Ramah Lingkungan',
          description: 'Produksi berkelanjutan menggunakan pewarna berbasis air dan praktik manufaktur yang bertanggung jawab terhadap lingkungan'
        }
      ]
    },
    contact: {
      title: 'Mari Berkreasi',
      titleGradient: 'Bersama',
      subtitle: 'Mulai proyek pareo kustom Anda dengan Bahtera Lima Utama',
      form: {
        services: 'Pilih Layanan',
        serviceOptions: [
          'Desain Kustom',
          'Pesanan Massal',
          'Permintaan Sampel',
          'Pertanyaan Kemitraan'
        ],
        name: 'Nama Lengkap',
        phone: 'Nomor Telepon',
        email: 'Alamat Email',
        message: 'Pesan Anda',
        messagePlaceholder: 'Ceritakan tentang kebutuhan proyek Anda, jumlah yang diinginkan, timeline, dan preferensi desain tertentu...',
        submit: 'Kirim Pesan',
        sending: 'Mengirim...',
        success: 'Pesan berhasil dikirim! Kami akan merespons dalam 24 jam.',
        error: 'Gagal mengirim pesan. Silakan coba lagi.'
      },
      info: {
        title: 'Informasi Kontak',
        address: 'Alamat Pabrik',
        addressDetail: 'Gepuro, Watukebo, Kec. Rogojampi, Kabupaten Banyuwangi, Jawa Timur 68462',
        phone: 'Nomor Telepon',
        email: 'Alamat Email',
        hours: 'Jam Operasional',
        hoursDetail: 'Senin - Sabtu: 08:00 - 17:00',
        whatsapp: 'Chat di WhatsApp'
      }
    },
    whatsapp: {
      message: 'Halo Bahtera Lima Utama! Saya tertarik untuk mengetahui lebih lanjut tentang produk pareo Anda.'
    }
  }
};

export const products = [
  {
    id: 1,
    type: 'Contemporary Geometric Pareo',
    materials: ['Rayon', 'Cotton Blend', 'Silk'],
    production: 'Hand-painted',
    moq: '100 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain1.jpeg'
  },
  {
    id: 2,
    type: 'Modern Abstract Pareo',
    materials: ['Cotton', 'Viscose', 'Linen Blend'],
    production: 'Hand-painted',
    moq: '150 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain2.jpeg'
  },
  {
    id: 3,
    type: 'Minimalist Wave Pareo',
    materials: ['Rayon', 'Cotton', 'Modal'],
    production: 'Hand-painted',
    moq: '120 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain3.jpeg'
  },
  {
    id: 4,
    type: 'Contemporary Tropical Pareo',
    materials: ['Silk Blend', 'Rayon', 'Cotton'],
    production: 'Hand-painted',
    moq: '100 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain4.jpeg'
  },
  {
    id: 5,
    type: 'Modern Gradient Pareo',
    materials: ['Rayon', 'Viscose', 'Cotton Blend'],
    production: 'Hand-painted',
    moq: '150 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain5.jpeg'
  },
  {
    id: 6,
    type: 'Abstract Art Pareo',
    materials: ['Cotton', 'Linen', 'Rayon'],
    production: 'Hand-painted',
    moq: '100 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain6.jpeg'
  },
  {
    id: 7,
    type: 'Contemporary Floral Pareo',
    materials: ['Silk', 'Rayon', 'Cotton Blend'],
    production: 'Hand-painted',
    moq: '120 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain7.jpeg'
  },
  {
    id: 8,
    type: 'Modern Marble Pareo',
    materials: ['Rayon', 'Cotton', 'Viscose'],
    production: 'Hand-painted',
    moq: '150 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain8.jpeg'
  },
  {
    id: 9,
    type: 'Watercolor Effect Pareo',
    materials: ['Cotton Blend', 'Rayon', 'Linen'],
    production: 'Hand-painted',
    moq: '100 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain9.jpeg'
  },
  {
    id: 10,
    type: 'Contemporary Stripe Pareo',
    materials: ['Rayon', 'Viscose', 'Cotton'],
    production: 'Hand-painted',
    moq: '120 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain10.jpeg'
  },
  {
    id: 11,
    type: 'Modern Botanical Pareo',
    materials: ['Cotton', 'Silk Blend', 'Rayon'],
    production: 'Hand-painted',
    moq: '150 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain11.jpeg'
  },
  {
    id: 12,
    type: 'Abstract Expression Pareo',
    materials: ['Rayon', 'Cotton Blend', 'Viscose'],
    production: 'Hand-painted',
    moq: '100 pieces',
    customDesign: true,
    exportReady: true,
    image: 'https://bahteralimautama.com/image/kain12.jpeg'
  }
];

export const contactInfo = {
  phone: '+62 817-7909-7471',
  phone2: '+62 819-9917-6174',
  email: 'yasminalydrs17@gmail.com',
  address: 'Gepuro, Watukebo, Kec. Rogojampi, Kabupaten Banyuwangi, Jawa Timur 68462',
  whatsapp: '+6281779097471',
  whatsapp2: '+6281999176174',
  businessHours: 'Monday - Saturday: 8:00 AM - 5:00 PM'
};
